import WxAutocompleteWidget from './wxAutocompleteWidget.vue';

export { WxAutocompleteWidget };
export default WxAutocompleteWidget;
